import React from 'react';
import { Card } from 'react-bootstrap';
import { Check } from 'react-feather';

const CreditSummaryAudit = ({ title, icon, value }) => {
  return (
    <Card className='border-0 shadow rounded-3 mb-lg-auto h-100'>
      <div className='d-flex p-3 rounded align-items-center'>
        <div className='d-flex bg-light-blue' style={{ borderRadius: '50%', height: '40px', width: '40px' }}>
          {icon ? (
            <img src={icon} alt='premium stars' fill='var(--bs-primary)' className='text-primary m-auto' width='30' height='30' />
          ) : (
            <div className='bg-transparent border border-primary border-2 text-center rounded-circle m-auto' style={{ padding: '0 2px' }}>
              <Check className='text-primary m-auto' width={18} height={12} strokeWidth={4} />
            </div>
          )}
        </div>
        <div className='ps-3'>
          <div className='text-light-gray fw-light lh-1 mb-2' style={{ fontSize: '15px', height: '30' }}>
            {title}
          </div>
          <div className='font-weight-bold h2 lh-1 mb-0'>{value}</div>
        </div>
      </div>
    </Card>
  );
};

export default CreditSummaryAudit;
